import classNames from 'classnames';

export default function Full(props: { children: React.ReactNode; className?: string }) {
  return (
    <div className="w-full h-full flex flex-1 items-stretch justify-stretch">
      <div className={classNames(props.className, 'flex-1')}>{props.children}</div>
    </div>
  );
}
